import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=06f4b418&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=06f4b418&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f4b418",
  null
  
)

export default component.exports